
/*
 * BUILD @athena/forge v9.0.0
 * THIS IS AN AUTOGENERATED FILE
 */

import React from 'react';
import IconBase from '../_IconBase';
const Success = props => {
  const modClassName = props.className ? props.className + ' fe_c_icon--success-solid' : ' fe_c_icon--success-solid';

  return (
    <IconBase viewBox="0 0 25 25" {...props} className={ modClassName }>
      <g>
        <g className="fe_c_icon__background">
          <rect width="25" height="25"></rect>
        </g>
        <g>
          <g>
            <circle cx="12.5" cy="12.5" r="10.6" className="fe_c_icon__icon fe_c_icon__icon--secondary"></circle>
            <polygon points="11.6 16.8 7.9 13.1 9.1 11.9 11.5 14.3 15.9 9 17.2 10 11.6 16.8" className="fe_c_icon__icon fe_c_icon__icon--invert"></polygon>
          </g>
        </g>
      </g>
    </IconBase>);
};

Success.defaultProps = {
  title: 'Success',
};

export default Success;
